import React, { Component, useState } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { IngresoForm } from "./components/IngresoForm";
import "./RecepcionTraslado.css";

class RecepcionTraslado extends Component {
    state = {
        traslado_id: null,
    };

    componentWillMount() {
        this.setState({ traslado_id: this.props.match.params.id });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    navigateToDetail = (id) => {
        this.props.history.replace(`/ingreso/${id}`);
    }

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="traslados_activo"
                    titulo="RECEPCIONAR TRASLADO"
                    subtitulo="Confirmar recepción"
                    col="12"
                >
                    <IngresoForm
                        traslado_id={this.state.traslado_id}
                        regresar={this.regresar}
                        navigateToDetail={this.navigateToDetail}
                        configuraciones={this.props.configuraciones}
                        user={this.props.user}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(RecepcionTraslado);

